import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

const MetricsBarChart = ({data}) => {

  return (
    <div className="text-black">
    <h2 className="text-lg font-semibold mb-4">Field Coverage</h2>
      <ResponsiveContainer width="100%" height={450}>
        <BarChart
          data={data}
          margin={{
            top: 20,
            right: 50,
            left: 50,
            bottom: 60
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis 
            dataKey="name" 
            angle={-45}
            textAnchor="end"
            height={60}
          />
          <YAxis />
          <Tooltip />
          <Bar dataKey="value" fill="#8884d8" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MetricsBarChart;